import { zIndex, opacity, breakpoints } from "../../primitives/layout";
import type { LayoutTheme } from "../../semantic/layout";

export const baseLayout: LayoutTheme = {
  zIndex: {
    hide: zIndex.hide,
    base: zIndex.base,
    dropdown: zIndex.dropdown,
    sticky: zIndex.sticky,
    modal: zIndex.modal,
    tooltip: zIndex.tooltip,
  },
  opacity: {
    transparent: opacity[0],
    subtle: opacity[10],
    muted: opacity[40],
    opaque: opacity[100],
  },
  breakpoints: {
    sm: breakpoints.sm,
    md: breakpoints.md,
    lg: breakpoints.lg,
    xl: breakpoints.xl,
    "2xl": breakpoints["2xl"],
  },
};
